import {dashboardTypeLabels} from '@github-ui/shared-dashboard-sidebar/types/dashboard-types'
import type {EmptyListState, EmptyListMessages} from '../types/blankslate-types'

/**
 * Single source of truth for empty-state blankslate messages.
 * Used by both the visual blankslate and screen-reader announcements
 * so the two stay consistent.
 */
export function getEmptyListMessages({
  dashboardType,
  filtered,
  currentPage,
  pageCount,
  errorMessage,
}: EmptyListState): EmptyListMessages {
  const dashboardLabel = dashboardTypeLabels[dashboardType]

  if (errorMessage) {
    return {heading: 'Invalid query', description: errorMessage}
  }

  if (pageCount > 0 && currentPage > pageCount) {
    return {heading: `No more ${dashboardLabel}`, description: 'Visit a lower page.'}
  }

  if (filtered) {
    return {
      heading:
        dashboardType === 'issues' ? 'No results matched your search' : `No ${dashboardLabel} matched your search`,
      description: 'Try a different search query.',
    }
  }

  return {heading: 'Enter a query to start searching.'}
}
